import { render } from "./CommunicationsTable.vue?vue&type=template&id=2c31e494"
import script from "./CommunicationsTable.vue?vue&type=script&lang=js"
export * from "./CommunicationsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__